import { object, number, string, array, nativeEnum, ZodIssueCode } from 'zod';

import { IS_POSITIVE, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { Constraint_Purchase_Threshold_Counting_Attribute } from '@occc/graphql';
import { ProductGroupsSchema, withIsEnabled } from '@occc/validation';

export const purchaseConstraintItemSchema = object({
  id: string().optional(),
  threshold: number().optional(),
  countProductsBy: nativeEnum(Constraint_Purchase_Threshold_Counting_Attribute, {
    required_error: IS_REQUIRED,
  }),
  eligibleProductGroups: ProductGroupsSchema,
});

const MinimumPurchaseConstraintsEnabledSchema = object({
  items: array(purchaseConstraintItemSchema)
    .min(1, IS_REQUIRED)
    .superRefine((items, ctx) => {
      items.forEach((item, index) => {
        if (item.threshold == null) {
          ctx.addIssue({
            code: ZodIssueCode.custom,
            path: [index, 'threshold'],
            message: IS_REQUIRED,
          });
        } else if (item.threshold <= 0) {
          ctx.addIssue({
            code: ZodIssueCode.custom,
            path: [index, 'threshold'],
            message: IS_POSITIVE,
          });
        }
      });
    }),
});

const MinimumPurchaseConstraintsDisabledSchema = object({
  items: array(
    purchaseConstraintItemSchema
      .extend({
        eligibleProductGroups: array(ProductGroupsSchema.element).optional(),
      })
      .partial(),
  )
    .optional()
    .default([]),
});

export const minimumPurchaseConstraintsSchema = withIsEnabled(
  MinimumPurchaseConstraintsEnabledSchema,
  MinimumPurchaseConstraintsDisabledSchema,
);

export const minimumPurchaseFormSchema = object({
  minimumPurchaseConstraints: minimumPurchaseConstraintsSchema,
});

export const zodMinimumPurchaseConstraintsSchema = minimumPurchaseConstraintsSchema;
